/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Impero API
 * Legacy Impero .NET API (served under /v1).
 */
import { useQuery, useSuspenseQuery } from "@tanstack/react-query";
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseQueryResult,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseQueryOptions,
    UseQueryResult,
    UseSuspenseQueryOptions,
    UseSuspenseQueryResult,
} from "@tanstack/react-query";

import axios from "axios";
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

import type {
    LegacyControlProgramExportParams,
    LegacyControlProgramViewModelWithUserMap,
} from "../model";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

const withQueryKey = <T extends object, K>(
    query: T,
    queryKey: K
): T & { queryKey: K } => {
    const result = { queryKey } as T & { queryKey: K };
    for (const key of Object.keys(query)) {
        // The explicit queryKey always wins, matching the previous
        // `{ ...query, queryKey }` spread where it was set last.
        if (key === "queryKey") continue;
        Object.defineProperty(result, key, {
            enumerable: true,
            configurable: true,
            get: () => (query as Record<string, unknown>)[key],
        });
    }
    return result;
};

export const legacyControlProgramGet = (
    id: number,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<LegacyControlProgramViewModelWithUserMap>> => {
    return axios.get(`/v1/ControlProgram/Get/${id}`, options);
};

export const getLegacyControlProgramGetQueryKey = (id: number) => {
    return [`/v1/ControlProgram/Get/${id}`] as const;
};

export const getLegacyControlProgramGetQueryOptions = <
    TData = Awaited<ReturnType<typeof legacyControlProgramGet>>,
    TError = AxiosError<unknown>,
>(
    id: number,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof legacyControlProgramGet>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getLegacyControlProgramGetQueryKey(id);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof legacyControlProgramGet>>
    > = ({ signal }) =>
        legacyControlProgramGet(id, { signal, ...axiosOptions });

    return {
        queryKey,
        queryFn,
        enabled: id !== null && id !== undefined,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof legacyControlProgramGet>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LegacyControlProgramGetQueryResult = NonNullable<
    Awaited<ReturnType<typeof legacyControlProgramGet>>
>;
export type LegacyControlProgramGetQueryError = AxiosError<unknown>;

export function useLegacyControlProgramGet<
    TData = Awaited<ReturnType<typeof legacyControlProgramGet>>,
    TError = AxiosError<unknown>,
>(
    id: number,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof legacyControlProgramGet>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof legacyControlProgramGet>>,
                    TError,
                    Awaited<ReturnType<typeof legacyControlProgramGet>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLegacyControlProgramGet<
    TData = Awaited<ReturnType<typeof legacyControlProgramGet>>,
    TError = AxiosError<unknown>,
>(
    id: number,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof legacyControlProgramGet>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof legacyControlProgramGet>>,
                    TError,
                    Awaited<ReturnType<typeof legacyControlProgramGet>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLegacyControlProgramGet<
    TData = Awaited<ReturnType<typeof legacyControlProgramGet>>,
    TError = AxiosError<unknown>,
>(
    id: number,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof legacyControlProgramGet>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useLegacyControlProgramGet<
    TData = Awaited<ReturnType<typeof legacyControlProgramGet>>,
    TError = AxiosError<unknown>,
>(
    id: number,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof legacyControlProgramGet>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getLegacyControlProgramGetQueryOptions(id, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getLegacyControlProgramGetSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof legacyControlProgramGet>>,
    TError = AxiosError<unknown>,
>(
    id: number,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof legacyControlProgramGet>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getLegacyControlProgramGetQueryKey(id);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof legacyControlProgramGet>>
    > = ({ signal }) =>
        legacyControlProgramGet(id, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof legacyControlProgramGet>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LegacyControlProgramGetSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof legacyControlProgramGet>>
>;
export type LegacyControlProgramGetSuspenseQueryError = AxiosError<unknown>;

export function useLegacyControlProgramGetSuspense<
    TData = Awaited<ReturnType<typeof legacyControlProgramGet>>,
    TError = AxiosError<unknown>,
>(
    id: number,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof legacyControlProgramGet>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLegacyControlProgramGetSuspense<
    TData = Awaited<ReturnType<typeof legacyControlProgramGet>>,
    TError = AxiosError<unknown>,
>(
    id: number,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof legacyControlProgramGet>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLegacyControlProgramGetSuspense<
    TData = Awaited<ReturnType<typeof legacyControlProgramGet>>,
    TError = AxiosError<unknown>,
>(
    id: number,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof legacyControlProgramGet>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useLegacyControlProgramGetSuspense<
    TData = Awaited<ReturnType<typeof legacyControlProgramGet>>,
    TError = AxiosError<unknown>,
>(
    id: number,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof legacyControlProgramGet>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getLegacyControlProgramGetSuspenseQueryOptions(
        id,
        options
    );

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const legacyControlProgramExport = (
    id: number,
    params?: LegacyControlProgramExportParams,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<Blob>> => {
    return axios.get(`/v1/ControlProgram/Export/${id}`, {
        responseType: "blob",
        paramsSerializer: { indexes: null },
        ...options,
        params: { ...params, ...options?.params },
    });
};

export const getLegacyControlProgramExportQueryKey = (
    id: number,
    params?: LegacyControlProgramExportParams
) => {
    return [
        `/v1/ControlProgram/Export/${id}`,
        ...(params ? [params] : []),
    ] as const;
};

export const getLegacyControlProgramExportQueryOptions = <
    TData = Awaited<ReturnType<typeof legacyControlProgramExport>>,
    TError = AxiosError<unknown>,
>(
    id: number,
    params?: LegacyControlProgramExportParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof legacyControlProgramExport>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getLegacyControlProgramExportQueryKey(id, params);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof legacyControlProgramExport>>
    > = ({ signal }) =>
        legacyControlProgramExport(id, params, { signal, ...axiosOptions });

    return {
        queryKey,
        queryFn,
        enabled: id !== null && id !== undefined,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof legacyControlProgramExport>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LegacyControlProgramExportQueryResult = NonNullable<
    Awaited<ReturnType<typeof legacyControlProgramExport>>
>;
export type LegacyControlProgramExportQueryError = AxiosError<unknown>;

export function useLegacyControlProgramExport<
    TData = Awaited<ReturnType<typeof legacyControlProgramExport>>,
    TError = AxiosError<unknown>,
>(
    id: number,
    params: undefined | LegacyControlProgramExportParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof legacyControlProgramExport>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof legacyControlProgramExport>>,
                    TError,
                    Awaited<ReturnType<typeof legacyControlProgramExport>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLegacyControlProgramExport<
    TData = Awaited<ReturnType<typeof legacyControlProgramExport>>,
    TError = AxiosError<unknown>,
>(
    id: number,
    params?: LegacyControlProgramExportParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof legacyControlProgramExport>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof legacyControlProgramExport>>,
                    TError,
                    Awaited<ReturnType<typeof legacyControlProgramExport>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLegacyControlProgramExport<
    TData = Awaited<ReturnType<typeof legacyControlProgramExport>>,
    TError = AxiosError<unknown>,
>(
    id: number,
    params?: LegacyControlProgramExportParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof legacyControlProgramExport>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useLegacyControlProgramExport<
    TData = Awaited<ReturnType<typeof legacyControlProgramExport>>,
    TError = AxiosError<unknown>,
>(
    id: number,
    params?: LegacyControlProgramExportParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof legacyControlProgramExport>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getLegacyControlProgramExportQueryOptions(
        id,
        params,
        options
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getLegacyControlProgramExportSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof legacyControlProgramExport>>,
    TError = AxiosError<unknown>,
>(
    id: number,
    params?: LegacyControlProgramExportParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof legacyControlProgramExport>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getLegacyControlProgramExportQueryKey(id, params);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof legacyControlProgramExport>>
    > = ({ signal }) =>
        legacyControlProgramExport(id, params, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof legacyControlProgramExport>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LegacyControlProgramExportSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof legacyControlProgramExport>>
>;
export type LegacyControlProgramExportSuspenseQueryError = AxiosError<unknown>;

export function useLegacyControlProgramExportSuspense<
    TData = Awaited<ReturnType<typeof legacyControlProgramExport>>,
    TError = AxiosError<unknown>,
>(
    id: number,
    params: undefined | LegacyControlProgramExportParams,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof legacyControlProgramExport>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLegacyControlProgramExportSuspense<
    TData = Awaited<ReturnType<typeof legacyControlProgramExport>>,
    TError = AxiosError<unknown>,
>(
    id: number,
    params?: LegacyControlProgramExportParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof legacyControlProgramExport>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLegacyControlProgramExportSuspense<
    TData = Awaited<ReturnType<typeof legacyControlProgramExport>>,
    TError = AxiosError<unknown>,
>(
    id: number,
    params?: LegacyControlProgramExportParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof legacyControlProgramExport>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useLegacyControlProgramExportSuspense<
    TData = Awaited<ReturnType<typeof legacyControlProgramExport>>,
    TError = AxiosError<unknown>,
>(
    id: number,
    params?: LegacyControlProgramExportParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof legacyControlProgramExport>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getLegacyControlProgramExportSuspenseQueryOptions(
        id,
        params,
        options
    );

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}
